import React from "react";

const Selection = () => {
    return (
        <div>

            {/*  This is component for "Selection" tab */}

            <div className="selection flex justify-between gap-12 2xl:flex-row lg:flex-col max-[600px]:flex-col">
                <div className="left w-2/5 flex flex-col justify-between lg:w-full max-[600px]:w-full">

                    {/* Header */}

                    <div className="top">
                        <h6 className="text-black font-medium text-base">
                            Premier Advantage Fixed Options Home Loan 2 Yrs $150K * $249K
                            (Principal & Interest)
                        </h6>
                        <p className="mt-8 text-base font-normal max-[600px]:mt-4">
                            Your property may not meet the eligibility criteria due to one or
                            more reasons. This could be because your property isn't
                            categorized as an investment property, doesn't meet the necessary
                            Debt-Service Coverage Ratio (DSCR) for documentation, or the
                            applicant isn't identified as a foreign national. Each of these
                            factors is essential in determining eligibility for the product.
                        </p>
                    </div>

                    <div className="bottom">
                        <button className="p-3 mt-10  rounded-lg border-sky-400 border flex items-center text-blue-500	gap-2">
                            <img src="/document-pdf.svg" alt="" />
                            Download PDF
                        </button>
                    </div>
                </div>

                <div className="right w-3/5 lg:w-full max-[600px]:w-full">
                    <img src="/selection.png" alt="" className="hidden" />
                </div>
            </div>
        </div>
    );
};

export default Selection;
